import { SurveyKeys } from '~/lib/constants/survey/SurveyKeys';
import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const SurveyNameToSurveyKeyMap: Record<SurveyName, SurveyKeys | ''> = {
  [SurveyName.ADMISSIONS_INTAKE]: SurveyKeys.ADMISSIONS_INTAKE,
  [SurveyName.ADMISSIONS_NPS]: SurveyKeys.ADMISSIONS_NPS,
  [SurveyName.AIMS]: SurveyKeys.AIMS,
  [SurveyName.ARFID]: SurveyKeys.ARFID_KEY,
  [SurveyName.AUDIT]: SurveyKeys.AUDIT_KEY,
  [SurveyName.BAS]: SurveyKeys.BAS_KEY,
  [SurveyName.C_SSRS_LIFETIME]: SurveyKeys.C_SSRS_LIFETIME_KEY,
  [SurveyName.C_SSRS_LR_SCREENER]: SurveyKeys.C_SSRS_LR_SCREENER_KEY,
  [SurveyName.C_SSRS_SLC_SCREENER]: SurveyKeys.C_SSRS_SLC_SCREENER_KEY,
  [SurveyName.C_SSRS_RECENT_SCREENER]: SurveyKeys.C_SSRS_RECENT_SCREENER_KEY,
  [SurveyName.DISCHARGE_SUMMARY]: SurveyKeys.DISCHARGE_SUMMARY,
  [SurveyName.DUDIT]: SurveyKeys.DUDIT,
  [SurveyName.C_SSRS_SINCE_LAST_CONTACT]:
    SurveyKeys.C_SSRS_SINCE_LAST_CONTACT_KEY,
  [SurveyName.CET]: SurveyKeys.CET_KEY,
  [SurveyName.EARLY_RESPONSE_CHECK_IN]: SurveyKeys.EARLY_RESPONSE_CHECK_IN_KEY,
  [SurveyName.EDE_Q]: SurveyKeys.EDE_Q_KEY,
  [SurveyName.FNS]: SurveyKeys.FNS_KEY,
  [SurveyName.GAD7]: SurveyKeys.GAD7_KEY,
  [SurveyName.LETHAL_MEANS]: SurveyKeys.LETHAL_MEANS_KEY,
  [SurveyName.MENTOR_MATCHING]: '',
  [SurveyName.MP_INTAKE_ASSESSMENT]: SurveyKeys.MP_INTAKE_ASSESSMENT,
  [SurveyName.NIAAA_BSTAD]: SurveyKeys.NIAAA_BSTAD_KEY,
  [SurveyName.NIAS]: SurveyKeys.NIAS_KEY,
  [SurveyName.NON_ARFID]: SurveyKeys.NON_ARFID_KEY,
  [SurveyName.NPS]: SurveyKeys.NPS_KEY,
  [SurveyName.PARDI_ARQ_PARENT]: SurveyKeys.PARDI_ARQ_PARENT_KEY,
  [SurveyName.PARDI_ARQ_SELF]: SurveyKeys.PARDI_ARQ_SELF_KEY,
  [SurveyName.PATIENT_EXPERIENCE]: SurveyKeys.PATIENT_EXPERIENCE,
  [SurveyName.PHQ8]: SurveyKeys.PHQ9_KEY,
  [SurveyName.PHQ9]: SurveyKeys.PHQ9_KEY,
  [SurveyName.POP]: SurveyKeys.POP,
  [SurveyName.PSEA]: SurveyKeys.PSEA_KEY,
  [SurveyName.QUALITY_OF_LIFE]: SurveyKeys.QUALITY_OF_LIFE_KEY,
  [SurveyName.SAFETY_PLAN]: SurveyKeys.SAFETY_PLAN_KEY,
  [SurveyName.SAMPLE_SURVEY]: '',
  [SurveyName.TREATMENT_UPDATE]: SurveyKeys.TREATMENT_UPDATE,
  [SurveyName.PCL5]: SurveyKeys.PCL5_KEY,
};
